/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';
// import { useIntl } from 'umi';
// import moment from 'moment';
import { get } from 'lodash';
import { Text } from '@digitalc/dxp-ui';
import useGCPI18n from '@/hooks/useGCPI18n';
import { numberFormat, formatDate, getThemeImgByKey } from '@/utils/utils';
import useResponsive from '@/hooks/useResponsive';
// import defaultImg from '@/assets/images/point/defaultOfferImg.png';
import styles from './index.less';

const CardItem = props => {
  // 响应式 hook
  useResponsive();

  // const intl = useIntl();

  const { data = {}, dxpToken, isMulPoints } = props;
  const GCPI18n = useGCPI18n();
  // 时间格式化处理
  // const FormatTime = timeValue => {
  //   const newFormatTime = moment(timeValue, 'YYYYMMDDhhmmss').locale('en').format('DD MMM YYYY HH:mm:ss');
  //   return newFormatTime;
  // };

  const skuName = get(data, 'orderSkuList[0].skuName');
  const totalAmount = get(data, 'totalAmountDisplay');
  const imageUrl = get(data, 'orderSkuList[0].imageUrl');
  const pointAcctTypeName = get(data, 'orderSkuList[0].pointAcctTypeName');
  const createdDate = formatDate(get(data, 'createdDate'));

  return (
    <div className={styles.wrap} style={{ padding: `${dxpToken.spacingGapMd / 100}rem` }}>
      <div className={styles.content}>
        <div className={styles.imgStyle}>
          <img src={imageUrl || getThemeImgByKey('offerDefThumbnail')} alt="" />
        </div>
        <div className={styles.wordsDetail}>
          <Text
            style={{ marginBottom: '0.04rem', color: dxpToken.colorTextNeutral }}
            breakpoint="Mobile"
            size="ContentC14Bold"
          >
            {skuName || '-'}
          </Text>
          <Text
            style={{ marginBottom: '0.04rem', color: dxpToken.colorTextSubtle }}
            breakpoint="Mobile"
            size="ContentC12Regular"
          >
            {createdDate || '-'}
          </Text>
          <div className={styles.pointWrap}>
            <Text
              style={{ color: dxpToken.colorTextNeutral }}
              breakpoint="Mobile"
              size="ContentC16Bold"
            >{`${numberFormat(totalAmount || 0)} ${GCPI18n({ id: 'lb_point_points' })}`}</Text>
            {isMulPoints && pointAcctTypeName && (
              <div className={styles.pointTypeName}>
                <Text
                  breakpoint="Mobile"
                  size="ContentC12Bold"
                  style={{ color: dxpToken.colorTagBlack }}
                >
                  {pointAcctTypeName}
                </Text>
              </div>
            )}
          </div>
          {/* <div className={styles.priceWrap}>
            <span className={styles.point}>{}</span>
            <span className={styles.symbol}>{}</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default CardItem;
